import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import * as ExcessUtil from 'notebook/tables/excess/Util';
import {formatTypedValue} from 'notebook/tables/typed-values/DataTypes';
import {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';

export default {
  name: 'LEN',
  category: FunctionCategory.TEXT,
  shortDescription: 'Length of a string.',
  description: 'Returns the length of a string.',
  params: [
    {
      name: 'text',
      type: ArgType.singularValue,
      description: 'The string whose length will be returned.',
      coerce: (typedValue: TypedValue, context?): string =>
        formatTypedValue(typedValue, {}, '', undefined, context),
    },
  ],
  returnType: ExcessUtil.VALUE_TYPES.NUMBER,
  eval: (text: string): number => text.length,
} satisfies EvaluablePrimitiveSpreadsheetFunction;
